import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { PlusIcon } from "@heroicons/react/24/outline";
import {
  deleteServiceById,
  fetchAllservices,
} from "../../../../redux/reducer/servicesReducer";
import ServicesTableDetails from "./ServicesTableDetails";
import AddServiceForm from "./AddServiceForm";

const ServicesSettings = () => {
  const [editingOrder, setEditingOrder] = useState(null);
  const [pricingOrder, setPricingOrder] = useState(null);
  const dispatch = useDispatch();
  const { allServices, loading, error } = useSelector(
    (state) => state.ourServices
  );
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);

  const headers = [
    "ID",
    "Name EN",
    "Name AR",
    "ShortDes EN",
    "ShortDes AR",
    "image",
    "Actions",
  ];

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchAllservices());
    };

    fetchData();
  }, [dispatch]);

  const loadService = async () => {
    try {
      await dispatch(fetchAllservices()).unwrap();
    } catch (error) {
      console.error("Failed to fetch the Service:", error);
    }
  };

  const handleDelete = (ServiceId) => {
    if (window.confirm("Are you sure you want to delete this Service?")) {
      dispatch(deleteServiceById(ServiceId))
        .unwrap()
        .then(() => {
          alert(t("serviceDeleted"));
          dispatch(fetchAllservices());
        })
        .catch((error) => alert(error || "Failed to delete Service."));
    }
  };

  const handleUpdate = () => {
    dispatch(fetchAllservices());
  };
  // console.log(allServices)
  return (
    <div className="mx-auto overflow-x-auto rounded-xl">
      <div className="flex justify-between my-4">
        <h1 className="text-xl font-bold text-black">Service</h1>
        <button
          className="flex gap-3 px-3 py-2 duration-300 rounded-lg bg-custom-yellow hover:bg-black group"
          onClick={() => {
            setShowForm(true);
          }}
        >
          <PlusIcon className="w-6 h-6 text-black group-hover:text-white" />
          <span className="text-black group-hover:text-white">Service</span>
        </button>
      </div>

      {loading ? (
        <p className="text-center text-gray-600">{t("Loading...")}</p>
      ) : error ? (
        <p className="text-center text-red-500">
          {t("Error")}: {error}
        </p>
      ) : allServices?.length === 0 ? (
        <p className="text-center text-gray-500">{t("No data found")}</p>
      ) : (
        <table className="w-full my-5">
          <thead>
            <tr className="text-sm text-black bg-custom-yellow">
              {headers.map((header, index) => (
                <th key={index} className="px-2 py-2 font-bold text-center">
                  {header}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {allServices?.map((service, index) => (
              <ServicesTableDetails
                key={service._id || index}
                index={index + 1}
                details={{
                  id: service._id,
                  number: index + 1,
                  img: service.img,
                  nameEN: service.title?.en,
                  nameAR: service.title?.ar,
                  descEN: service.shortDes?.en,
                  descAR: service.shortDes?.ar,
                }}
                isEditing={editingOrder === service._id}
                isPricing={pricingOrder === service._id}
                setEditingOrder={setEditingOrder}
                setPricingOrder={setPricingOrder}
                onUpdate={handleUpdate}
                onDelete={() => handleDelete(service._id)}
              />
            ))}
          </tbody>
        </table>
      )}
      {showForm && (
        <AddServiceForm
          onClose={() => {
            setShowForm(false);
            loadService();
          }}
        />
      )}
    </div>
  );
};

export default ServicesSettings;
